import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  propertyPanelHeader: {
    description: 'Header for the properties panel section in document designer',
    defaultMessage: '{element} Properties',
    id: '1AB59V',
  },
  deleteWidget: {
    description: 'Button label for deleting a widget',
    defaultMessage: 'Delete Widget',
    id: 'xQabL7',
  },
});
